import { CurrencyScale } from '../enums/currency-scale';
import { BaseCurrencyConversion } from '../base-currency-conversion';

export class CurrencyConversionPayload {
  conversions: BaseCurrencyConversion[];
  localCurrencyScale?: CurrencyScale;
}
